import React from "react";
import { useTranslation } from "react-i18next";
import { FormBuilder, formBuilderParams } from "components/FormBuilder/FormBuilder";

const PAGE_LOCALE_KEY = "page.employees.";
const FORM_LABEL_KEY = `${PAGE_LOCALE_KEY}employeeDetail.config.fields`;
const accessControlOption = [
  {
    title: "Default 6-digits Passcode",
    value: "Default",
    label: "Default 6-digits Passcode",
  },
  {
    title: "Gateway Password",
    value: "Gateway",
    label: "Gateway Password",
  },
  {
    title: "None",
    value: "None",
    label: "None",
  },
];

const EmployeeFunctionAccControlConfig = ({ formProps }) => {
  const { t } = useTranslation();

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    accessControlVoid: {
      fieldType: "selection",
      fieldName: "accessControlVoid",
      label: t(`${FORM_LABEL_KEY}.accessControlVoid`),
      mandatory: true,
      config: {
        options: accessControlOption,
      }
    },
    accessControlRefund: {
      fieldType: "selection",
      fieldName: "accessControlRefund",
      label: t(`${FORM_LABEL_KEY}.accessControlRefund`),
      mandatory: true,
      config: {
        options: accessControlOption,
      }
    },
    accessControlAuthorization: {
      fieldType: "selection",
      fieldName: "accessControlAuthorization",
      label: t(`${FORM_LABEL_KEY}.accessControlAuthorization`),
      mandatory: true,
      config: {
        options: accessControlOption,
      }
    },
    accessControlAuthComplete: {
      fieldType: "selection",
      fieldName: "accessControlAuthComplete",
      label: t(`${FORM_LABEL_KEY}.accessControlAuthComplete`),
      mandatory: true,
      config: {
        options: accessControlOption,
      }
    },
    accessControlHistory: {
      fieldType: "selection",
      fieldName: "accessControlHistory",
      label: t(`${FORM_LABEL_KEY}.accessControlHistory`),
      mandatory: true,
      config: {
        options: accessControlOption,
      }
    },
    accessControlSettlement: {
      fieldType: "selection",
      fieldName: "accessControlSettlement",
      label: t(`${FORM_LABEL_KEY}.accessControlSettlement`),
      mandatory: true,
      config: {
        options: accessControlOption,
      }
    },
    accessControlSetting: {
      fieldType: "selection",
      fieldName: "accessControlSetting",
      label: t(`${FORM_LABEL_KEY}.accessControlSetting`),
      mandatory: true,
      config: {
        options: accessControlOption,
      }
    },
    accessControlAuthTopUp: {
      fieldType: "selection",
      fieldName: "accessControlAuthTopUp",
      label: t(`${FORM_LABEL_KEY}.accessControlAuthTopUp`),
      mandatory: true,
      config: {
        options: accessControlOption,
      }
    },
    accessControlTipsAdjustment: {
      fieldType: "selection",
      fieldName: "accessControlTipsAdjustment",
      label: t(`${FORM_LABEL_KEY}.accessControlTipsAdjustment`),
      mandatory: true,
      config: {
        options: accessControlOption,
      }
    },
    accessControlScreenSaver: {
      fieldType: "selection",
      fieldName: "accessControlScreenSaver",
      label: t(`${FORM_LABEL_KEY}.accessControlScreenSaver`),
      mandatory: true,
      config: {
        options: accessControlOption,
      }
    },
  }

  return (
    <FormBuilder.Section
      title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.functionAccessControl`)}
      titleVariant="h3"
      padding={formBuilderParams.formSectionLeftPadding}>
      <FormBuilder.Row itemsPerRow={3}>
        {FormBuilder.buildFields({
          formProps, fields: [
            fieldsConfig.accessControlVoid,
            fieldsConfig.accessControlRefund,
            // fieldsConfig.accessControlAuthorization,
            // fieldsConfig.accessControlAuthComplete,
            fieldsConfig.accessControlHistory,
            // fieldsConfig.accessControlSettlement,
            // fieldsConfig.accessControlSetting,
            // fieldsConfig.accessControlAuthTopUp,
            // fieldsConfig.accessControlTipsAdjustment,
            // fieldsConfig.accessControlScreenSaver
          ]
        })}
      </FormBuilder.Row>
    </FormBuilder.Section>
  );
};

export default React.memo(EmployeeFunctionAccControlConfig);
